import Vue from 'vue';

export default {
  // 竞价大厅列表
  getDemandList(params) {
    return Vue.axios.get('/rx/user/api/v1.0/service/extend-info/list', { params });
  },
  getSubTypeList(params) {
    return Vue.axios.get('/rx/user/api/v1.0/service/extend-info/type/list', {
      headers: {
        tId: '66aaf74f247b9fffdb5eba08'
      },
      params
    });
  },
  getFieldList(params) {
    return Vue.axios.get('/rx/user/api/v1.0/service/extend-info-template/list', { params});
  },

  createDemand(payload) {
    return Vue.axios.post('/rx/user/api/v1.0/service/extend-info', payload);
  },

  getDetail(params) {
    return Vue.axios.get('/rx/user/api/v1.0/service/extend-info/detail', { params });
  }
};
